import { Div, Container, RightDiv, LogoCanto } from './styles';
import AdminPanelLoginView from '../../views/AdminPanelLogin/index.jsx';
import logoCanto from '../../assets/logoCanto.png';

import { deleteCookies } from '../../utils/functions';

function LoginAdmin() {


  // Deleta cookies ao montar o componente
  deleteCookies();

  return (
    <Div>
      <Container>
  

        <RightDiv>
           <LogoCanto src={logoCanto} alt="Logo Cantoneira" /> 
          <AdminPanelLoginView />
        </RightDiv>
      </Container>


    </Div>
  );
}

export default LoginAdmin;
